import React, { useState } from 'react';
import TradingViewChartIcon from './TradingViewChartIcon';
import './TopAdxTrendView.css';
import { ensureArray } from './config';

const TopAdxTrendView = ({ data }) => {
  const safeData = ensureArray(data);
  const timeFrames = [...new Set(safeData.map(d => d.timeFrame))].sort((a, b) => a - b);
  return (
    <div className="adx-view-container">
      {timeFrames.map(tf => (
        <AdxTimeFrameSection key={tf} timeFrame={tf} data={safeData.filter(d => d.timeFrame === tf)} />
      ))}
    </div>
  );
};

const AdxTimeFrameSection = ({ timeFrame, data }) => {
  const safeData = ensureArray(data);
  const [filters, setFilters] = useState({ symbol: '' });
  const [sortConfig, setSortConfig] = useState({ key: 'adx', direction: 'desc' });
  const [expanded, setExpanded] = useState(false);

  const symbols = [...new Set(safeData.map(d => d.symbol))];

  const filtered = safeData
    .filter(item => !filters.symbol || item.symbol === filters.symbol)
    .filter(item => parseFloat(item.adx) >= 20); // Basic threshold filter for strong trend

  const sorted = [...filtered].sort((a, b) => {
    const valA = parseFloat(a[sortConfig.key]) || 0;
    const valB = parseFloat(b[sortConfig.key]) || 0;
    return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
  });

  const displayData = expanded ? sorted : sorted.slice(0, 5);

  const handleSort = (key) => {
    setSortConfig(prev =>
      prev.key === key
        ? { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
        : { key, direction: 'asc' }
    );
  };

  return (
    <div className="tf-section">
      <h3>Top ADX Trend – {timeFrame} min</h3>
      <div className="filters">
        <select value={filters.symbol} onChange={e => setFilters({ ...filters, symbol: e.target.value })}>
          <option value="">Symbol</option>
          {symbols.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        {filtered.length > 5 && (
          <button className="expand-button" onClick={() => setExpanded(!expanded)}>
            {expanded ? 'Collapse' : 'Expand'}
          </button>
        )}
        <button onClick={() => setFilters({ symbol: '' })}>Clear Filters</button>
      </div>

      <div className="adx-table-wrapper">
        <table className="adx-table">
          <thead>
            <tr>
              <th>#</th>
              <th onClick={() => handleSort('symbol')}>Symbol</th>
              <th>Chart</th>               
              <th onClick={() => handleSort('adx')}>ADX</th>
              <th onClick={() => handleSort('marketPrice')}>Market Price</th>
              <th onClick={() => handleSort('change')}>Change %</th>
              <th onClick={() => handleSort('volumeChange')}>Vol Ch%</th>
            </tr>
          </thead>
          <tbody>
            {displayData.map((item, idx) => (
                <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.symbol}</td>
                <td>
                  <TradingViewChartIcon
                    symbol={item.symbol}
                    timeFrame={item.timeFrame}
                    exchange={item.exchange}
                  />
                </td>                  
                <td className={parseFloat(item.adx) > 25 ? 'adx-highlight' : ''}>
                    {item.adx}
                </td>
                <td>{item.marketPrice}</td>
                <td>{item.change}%</td>
                <td>{item.volumeChange}</td>                
                </tr>
            ))}
            </tbody>

        </table>
      </div>
    </div>
  );
};

export default TopAdxTrendView;
